import { apiService } from './api';
import Cookies from 'js-cookie';

export const authService = {
  // User registration
    signUp: async (userData) => {
      try {
        const response = await apiService.post('/account/register', userData);
        return {
          success: true,
          message: response.data
        };
      } catch (error) {
        // IdentityResult errors come as an array in error.response.data
        const errors = error.response?.data;
        return {
          success: false,
          errors: Array.isArray(errors) ? errors : ['Registration failed']
        };
      }
    },

   
    login: async (credentials) => {
        try {
          const response = await apiService.post('/account/login', credentials);
          if (response.data.token) {
            Cookies.set('Auth_Token', response.data.token, {
              expires: 1,            // 1 day
              secure: true,          // Only sent over HTTPS
              sameSite: 'strict',    // Prevents CSRF
              path: '/',             // Available throughout the site
            }); 

            const userInfo = {
                user: response.data.user, // contains role like "Admin"
                expiry: Date.now() + 24 * 60 * 60 * 1000, // 1-day session
              };
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
            return {
              success: true,
              data: response.data
            };
          }
          return {
            success: false,
            error: 'Invalid response from server'
          };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data || 'Login failed'
          };
        }
      },   
      // logout: () => {
      //   sessionStorage.removeItem('jwt_token');
      //   delete apiService.defaults.headers.common['Authorization'];
      //   localStorage.removeItem('userInfo');
      // },
    
      // // Helper to check if user is logged in
      // isAuthenticated: () => {
      //   return !!sessionStorage.getItem('jwt_token');
      // },
};